import { Language, TranslationMode } from '@lingvo-news/contracts';

export function parseModeParam(value: unknown): TranslationMode | null {
	const raw = typeof value==='string'
			? value
			:(Array.isArray(value) && typeof value[0]==='string' ? value[0]:undefined);
	if (!raw) return null;
	const normalized = raw.toLowerCase();
	return Object.values(TranslationMode).includes(normalized as TranslationMode) ? (normalized as TranslationMode):null;
}

export function parseLanguageParam(value: unknown): Language | null {
	const raw = typeof value==='string'
			? value
			:(Array.isArray(value) && typeof value[0]==='string' ? value[0]:undefined);
	if (!raw) return null;
	const normalized = raw.toLowerCase();
	return Object.values(Language).includes(normalized as Language) ? (normalized as Language):null;
}



